import allergeni from "../assets/allergeni.webp";
import "../style/allergeni.css";

const Allergeni = () => {
  return <img className="img" src={allergeni} alt="allegeni" />;
};

export default Allergeni;
